/* 🤖 this file was generated by script */
export const wiconTarget04 = {
  name: 'target_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8V5l3-3 1 2 2 1-3 3h-3zm0 0l-4 4m10 0A10 10 0 1112 2m5 10a5 5 0 11-5-5"/></svg>`,
};
